import devStatus, { domain } from 'shared/devStatus';

let base = 'http://localhost:5000';
if (devStatus) {
  base = domain;
}

export default base;
